import React from 'react';
import { Row, Col, Card, Spacer } from '@cleartrip/bento';

import { Target } from 'components/composite';

import { ReactComponent as Calendar } from 'assets/icons/calendar.svg';
import { ReactComponent as Checklist } from 'assets/icons/checklist.svg';
import { ReactComponent as CreditShell } from 'assets/icons/creditshell.svg';
import Clevertap from 'analytics'
import { scrollTo } from 'helper/scrollTo';

function TopNotch({checkListRef}) {
	function triggerClevertapEvent(value){
		Clevertap.event('Air_UI_action', {
			action_name: 'navigation_icon',
			action_value:value
		})
	}
	return (
		<Row>
			<Col span={12} xs={24}>
				<Card className='bc-neutral-100 bg-white ba br-4 p-4 flex flex-middle'>
					<Checklist width={48} height={48} className='c-neutral-400' />
					<Spacer className='pr-3' />
					<div onClick={() => triggerClevertapEvent('safety_checklist')}>
						<p className='c-neutral-900 fs-4 fw-500'>Prepare for your travel</p>
						<Spacer className='pt-1' />
						<Target handler={()=> scrollTo(checkListRef)} className='fs-3 c-pointer'>
							View safety checklist
						</Target>
					</div>
				</Card>
				<Spacer className='pt-4--xs' />
			</Col>
			<Col span={12} xs={24}>
				<Card className='bc-neutral-100 bg-white ba br-4 p-4 flex flex-middle'>
					<Calendar width={48} height={48} className='c-neutral-400' />
					<Spacer className='pr-3' />
					<div onClick={() => triggerClevertapEvent('airline_policies')}>
						<p className='c-neutral-900 fs-4 fw-500'>Cancellation and amendment</p>
						<Spacer className='pt-1' />
						<Target href='/coronahelp/' className='fs-3' blank>
							View airline policies
						</Target>
					</div>
				</Card>
				<Spacer className='pt-4--xs' />
			</Col>
		</Row>
	);
}

export default TopNotch;
